import {
	StaffPortalContext,
	useStaffPortalOverview,
} from "./staff-portal-context";

export function StaffPortalContextProvider({
	children,
	...props
}: React.PropsWithChildren<{
	tenant: string;
	venueId: string;
	timeZone: string;
}>) {
	const context = useStaffPortalOverview(props);

	return (
		<StaffPortalContext
			value={{
				...context,
			}}
		>
			<>{children}</>
		</StaffPortalContext>
	);
}
